import React from 'react';
import { logError } from '@/src/utils/sentry';
import PropTypes from 'prop-types';
import { createMetricSender } from '../../metrics/send-metric';
import FeedbackPage from '@pedidosya/web-fenix/system/FeedbackPage';
import FooterButton from '@pedidosya/web-fenix/system/FooterButton';

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showComponent: true,
    };
  }

  componentDidCatch(error) {
    const metricSender = createMetricSender();
    this.setState({
      showComponent: false,
    });
    logError('[APP_ERROR]', error);
    metricSender.sendClientError();
  }

  onClickFallback() {
    // This is intentional
  }

  render() {
    const { showComponent } = this.state;
    const { children, fallback } = this.props;
    return showComponent
      ? children
      : fallback || (
          <FeedbackPage
            description="Tuvimos un problema. Reintente nuevamente."
            title="Hubo un error"
            variant="error"
          >
            <FeedbackPage.FooterButton>
              <FooterButton.Button
                fullWidth
                hierarchy="primary"
                label="Reintentar"
                onClick={this.onClickFallback}
                size="large"
              />
            </FeedbackPage.FooterButton>
          </FeedbackPage>
        );
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node,
};

export default ErrorBoundary;
